<template>
	<vxe-modal v-model="modalShow" width="800" height="700" title="组件配置" show-footer destroy-on-close @show="show"
		@hide="hide" transfer :lock-scroll="false">
		<template #default>
			<el-button v-if="currentItem.fieldcomponent == 'select'" size="mini" type="primary" style="margin-bottom: 10px;" @click="emunShow">枚举</el-button>
			<el-button v-if="!currentItem.fieldcomponent" size="mini" type="primary" style="margin-bottom: 10px;" @click="setTextarea">富文本</el-button>
			<el-button size="mini" type="primary" style="margin-bottom: 10px;" @click="penetrateShow">穿透</el-button>
			
			<vJsoneditor v-model="editvalue" height="550px" :options="{mode:'code'}" />		
				
				
			<toolbar-emun :data="editvalue" ref="toolbarEmun" @success="setEmun" />
			<toolbar-penetrate :data="editvalue" ref="toolbarPenetrate" @success="setPenetrate" />
		</template>
		<template #footer>
			<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
			<vxe-button status="primary" content="确定" @click="editsubmit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<script>
	import vJsoneditor from 'v-jsoneditor'
	import toolbarEmun from './toolbar/emun.vue'
	import toolbarPenetrate from './toolbar/penetrate.vue'
	export default {
		props: {
			currentItem:{
				default: () => {
					return {}
				}
			},
			config: {
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				modalShow:false,
				editvalue: {}
			}
		},
		created() {


		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			emunShow(){
				this.$refs.toolbarEmun.modal_show()
			},
			penetrateShow(){
				this.$refs.toolbarPenetrate.modal_show()
			},
			setEmun(e){
				let obj = JSON.parse(JSON.stringify(this.editvalue))
				obj.options = e.data.map((item)=>{
					return {
						value:item.value,
						label:item.label
					}
				})
				this.editvalue = obj
			},
			setPenetrate(e){
				let obj = JSON.parse(JSON.stringify(this.editvalue))
				let penetrateModule = {}
				let penetrateComponent = {}
				e.data.forEach((item)=>{
					if(item.type == 'penetrateModule'){
						penetrateModule[item.regexp] = item.module
					}
					if(item.type == 'penetrateComponent'){
						penetrateComponent[item.regexp] = item.module
					}
				})
				if(Object.keys(penetrateModule).length != 0){
					obj.penetrateModule = penetrateModule
				}
				if(Object.keys(penetrateComponent).length != 0){
					obj.penetrateComponent = penetrateComponent
				}
				this.editvalue = obj
			},
			setTextarea(){
				let obj = JSON.parse(JSON.stringify(this.editvalue))
				if(!obj.inputprops){
					obj.inputprops = {...obj.inputprops,...{type:'textarea'}}
					obj.col = {span:24,offset:0}
				}else{
					delete(obj.inputprops)
					delete(obj.col)
				}
				this.editvalue = obj
			},
			show(){
				this.editvalue = this.config
			},
			hide(){
				
			},
			modal_show(){
				this.modalShow = true
			},
			editsubmit(){
				this.$emit('submit',this.editvalue)
				this.modalShow = false
			}
		},
		components: {
			vJsoneditor,
			toolbarEmun,
			toolbarPenetrate
		}
	}
</script>